import React from 'react';
import { whatsappLink } from '../data/site';

export const WhatsAppIcon = ({ size = 20, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M20.5 11.6a8.5 8.5 0 0 1-12.6 7.5L3 20.5l1.4-4.7a8.5 8.5 0 1 1 16.1-4.2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
    <path d="M8.3 7.4c-.3 0-.8.6-.8 1.3 0 2.3 3.7 6 6.3 6.2.8 0 1.5-.7 1.5-1.1 0-.3-1.8-1.5-2.1-1.4-.3.1-.7.8-1 .8-.5-.1-2.7-2-2.8-2.6 0-.3.7-.7.8-1 .1-.3-1.2-2.2-1.9-2.2Z" fill="currentColor" />
  </svg>
);

export const WhatsAppLink = ({ subject, children, className = '', testId, ...props }) => (
  <a href={whatsappLink(subject)} target="_blank" rel="noopener noreferrer"
    className={className} data-testid={testId} {...props}>{children}</a>
);

export const FloatingWhatsApp = () => (
  <WhatsAppLink className="floating-whatsapp" testId="floating-whatsapp" aria-label="Conversar com a FATT Elevadores no WhatsApp" title="Fale com a FATT no WhatsApp">
    <WhatsAppIcon size={28} /><span>Vamos conversar?</span>
  </WhatsAppLink>
);